import React, { useState } from 'react';

import './styles.css';

import { FaEye, FaEyeSlash } from "react-icons/fa";

import userServices from '../../../services/userServices';

export default function LoginForm(props) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [visiblePassword, setVisiblePassword] = useState(0);

    function changePasswordVisibility() {
        setVisiblePassword(!visiblePassword);
    }

    async function login() {
        const response = await userServices.login(email, password);
        // if (response.data && response.data.tipo && response.data.tipo === "academia") {
        if (response.status === 200) {
            props.setFormOn(0);
            setTimeout(() => props.setOption(1), 1000);
            setTimeout(() => props.setModulesOn(1), 1100);
        } else alert("Credenciais de acesso negadas");
    }

    async function forgotPassword() {
        const email = prompt("Digite seu email de usuário:");
        if (email) {
            var response = await userServices.forgotPassword(email);
            console.log(response);
        }
    }

    return (
        <form className={'login-form' + (props.hide ? ' none-opacity' : '')}>
            <h1>Login</h1>

            <label htmlFor="email">Email</label>
            <input
                required
                type="email"
                id="email"
                placeholder="Insira seu email aqui"
                onChange={(event) => setEmail(event.target.value)}
            />

            <label htmlFor="senha">Senha</label>
            <div className='login-form-password-input'>
                <input
                    required
                    type={visiblePassword ? "text" : "password"}
                    id="senha"
                    placeholder="Insira sua senha aqui"
                    onChange={(event) => setPassword(event.target.value)}
                />
                <button type="button" className="hide-password-icon" onClick={changePasswordVisibility}>
                    {visiblePassword ?
                        <FaEyeSlash size={16} color="#B2BFD8" />
                        :
                        <FaEye size={16} color="#B2BFD8" />
                    }
                </button>
            </div>

            <div className='login-form-password-options'>
                {/* <div>
                    <input type="checkbox" name="lembrar minha senha" id="lembrar" />
                    <label htmlFor="lembrar">Lembrar-me</label>
                </div> */}
                <button type='button' onClick={forgotPassword}>Esqueci minha senha</button>
            </div>

            <button type='button' className='login-button' onClick={login}>Entrar</button>
        </form>
    );
}
